import React, { useState } from "react";
import { Settings2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { CARD, PageNav } from "../components/PageChrome";
import { DatasourceList, DatasourcePage, useDatasources } from "../components/DatasourceList";
import MetadataEditor from "./MetadataEditor";

export default function Modify({ onBack }) {
  const { logout, user } = useAuth();
  const canWrite = !!user?.can_write;
  const list = useDatasources();
  const [target, setTarget] = useState(null);

  const closeEditor = () => { setTarget(null); list.reload(); };

  return (
    <div className="min-h-screen bg-slate-200 text-slate-900 font-sans">
      <PageNav accent="amber" label="MODIFY" user={user} onLogout={logout} />
      <main className="pt-28 pb-20 flex justify-center px-6">
        <div className="w-full max-w-5xl">
          <div className={`${CARD} p-8 md:p-12`}>
            <DatasourcePage
              onBack={onBack}
              title="MODIFY A DATASOURCE"
              intro="Pick a registered datasource to edit its metadata context. If its OpenAPI document also changed, you'll be asked and the source graph re-converted in the same step."
            >
              <DatasourceList
                list={list}
                user={user}
                accent="amber"
                renderAction={(ds) => (
                  <button
                    onClick={() => canWrite && setTarget(ds)}
                    disabled={!canWrite}
                    title={!canWrite ? "Requires an editor or administrator role" : undefined}
                    className="flex items-center justify-center gap-2 px-8 py-4 bg-amber-50 text-amber-700 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-amber-600 hover:text-white hover:shadow-xl hover:shadow-amber-100 transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-amber-50 disabled:hover:text-amber-700"
                  >
                    {canWrite ? <Settings2 size={14} /> : <Lock size={14} />}
                    Modify
                  </button>
                )}
              />
            </DatasourcePage>
          </div>
        </div>
      </main>

      {target && <MetadataEditor target={target} onCancel={closeEditor} onDone={onBack || closeEditor} />}
    </div>
  );
}
